import React from 'react';
import { MeatballMenu, Textarea } from 'ui';
import { ExternalMemberItemProps } from '../types';
import {
  ExternalMemberFormIds, maxDescriptionLength, maxLengthOfEmailInputValue
} from 'app/area/subscriber-groups/form/constants';
import styles from './external-members-item.scss';

export const ExternalMembersItem: React.FC<ExternalMemberItemProps> = ({
  item, validation, translation, removeAllExternalMembers, updateExternalMemberItem,
  resetValidation, removeExternalMember
}) => {

  const externalMemberId = item?.memberNo;

  const onNameChange = (name: string) => {
    resetValidation(externalMemberId, ExternalMemberFormIds.name);
    updateExternalMemberItem({ ...item, name });
  };

  const onEmailChange = (emailAddress: string) => {
    resetValidation(externalMemberId, ExternalMemberFormIds.emailAddress);

    updateExternalMemberItem({ ...item, emailAddress });
  };

  const onRemove = () => {
    resetValidation(externalMemberId, ExternalMemberFormIds.emailAddress);
    resetValidation(externalMemberId, ExternalMemberFormIds.name);
    removeExternalMember(externalMemberId);
  };

  const nameValidation = validation?.name?.messages?.some(message => message.parameters?.id === item.memberNo)
    ? validation?.name
    : undefined;

  const emailAddressValidation = validation?.emailAddress?.messages?.some(message => message.parameters?.id === item.memberNo)
    ? {
      ...validation?.emailAddress,
      messages: validation.emailAddress.messages.filter(message => message.parameters.id === item.memberNo)
    }
    : undefined;

  return <div className={styles.row}>
    <div className={styles.content}>
      <div className={styles.leftSide}>
        <div className={styles.leftSideColumn}>
          <div className={`${styles.defaultColumn} d-block`}>
            <Textarea
              componentId={ExternalMemberFormIds.name}
              onChange={onNameChange}
              maxLength={maxDescriptionLength}
              value={item?.name}
              validation={nameValidation} />
          </div>
        </div>
        <div className={styles.leftSideColumn}>
          <Textarea
            componentId={ExternalMemberFormIds.emailAddress}
            onChange={onEmailChange}
            maxLength={maxLengthOfEmailInputValue}
            value={item?.emailAddress}
            validation={emailAddressValidation} />
        </div>
      </div>
      <MeatballMenu className={styles.meatball} closeAfterClick={true}>
        <li>
          <button type="button" className="dropdown-item" onClick={onRemove}>
            {translation.remove}
          </button>
        </li>
        <li>
          <button type="button" className="dropdown-item" onClick={removeAllExternalMembers}>
            {translation.remove_all}
          </button>
        </li>
      </MeatballMenu>
    </div>
  </div>;
};
